/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Component } from '@angular/core';

import { ClarityDocComponent } from '../clarity-doc';

const ICONS_IMPORT_EXAMPLE = `
import '@cds/core/icon/register.js';
import { ClarityIcons, userIcon } from '@cds/core/icon';

ClarityIcons.addIcons(userIcon);
`;

const ICONS_INSTANTIATE_EXAMPLE = `<cds-icon shape="user"></cds-icon>`;

const ADD_ICONS_EXAMPLE = `ClarityIcons.addIcons(['my-custom-icon', '<svg ... >[your SVG code goes here]</svg>']);`;

const ICONS_CUSTOMIZE_EXAMPLE = `<cds-icon shape="my-custom-shape"></cds-icon>`;

const INERT_ICONS_EXAMPLE = `<cds-icon shape="bars"></cds-icon>`;

const INTERACTIVE_ICONS_EXAMPLE = `
<button class="btn" aria-label="toggle menu">
  <cds-icon shape="bars"></cds-icon>
  Menu
</button>
`;

const INTERACTIVE_ICONS_WITHOUT_DESCRIPTIVE_TEXT_EXAMPLE = `
<button class="btn btn-icon" aria-label="toggle menu">
  <cds-icon shape="bars"></cds-icon>
</button>
`;

const STATUS_OR_INDICATOR_ICONS_EXAMPLE = `
<p>
  <cds-icon shape="exclamation-triangle" role="img" aria-label="Usage Warning"></cds-icon>
  CPU usage is at 99% use.
</p>
`;

@Component({
  templateUrl: 'icons.demo.html',
  styleUrls: ['./icons.demo.scss'],
  host: {
    '[class.content-area]': 'true',
    '[class.dox-content-panel]': 'true',
  },
})
export class IconsDemo extends ClarityDocComponent {
  iconsImportExample = ICONS_IMPORT_EXAMPLE;
  iconsInstantiateExample = ICONS_INSTANTIATE_EXAMPLE;
  addIconsExample = ADD_ICONS_EXAMPLE;
  iconsCustomizeExample = ICONS_CUSTOMIZE_EXAMPLE;
  inertIconsExample = INERT_ICONS_EXAMPLE;
  interactiveIconsExample = INTERACTIVE_ICONS_EXAMPLE;
  interactiveIconsExampleWithoutDescriptiveText = INTERACTIVE_ICONS_WITHOUT_DESCRIPTIVE_TEXT_EXAMPLE;
  statusOrIndicatorIconsExample = STATUS_OR_INDICATOR_ICONS_EXAMPLE;

  constructor() {
    super('icons');
  }
}
